import React from 'react';
import styled from 'styled-components';
import FooterV2 from 'components/footer_v2';

const FooterContainer = styled.div`
  display: flex;
  position: fixed;
  width: 100%;
  bottom: 0;
  justify-content: center;
`;

const CustomPageFooter = ({ pathname }: {
  pathname: string;
}) => (
  <FooterContainer>
    <FooterV2 hashState={pathname} />
  </FooterContainer>
);

export default CustomPageFooter;
